import { ReactNode, useCallback } from 'react';
import {
  ConfirmModal,
  IConfirm,
} from '../../../components/dialogs/ConfirmModal';
import { AlertModal } from '../../../components/dialogs/AlertModal';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react-lite';

type TApiaUtilConfirm = Pick<
  IConfirm,
  | 'additionalButtons'
  | 'additionalButtonsOnRight'
  | 'cancelButtonText'
  | 'children'
  | 'className'
  | 'confirmButtonText'
  | 'confirmButtonVariant'
  | 'contentRef'
  | 'hideCancelButton'
  | 'hideConfirmButton'
  | 'title'
  | 'size'
  | 'variant'
  | 'htmlContent'
>;

type TApiaUtilInnerConfirm = TApiaUtilConfirm & { id: string } & Pick<
    IConfirm,
    'onCancel' | 'onConfirm'
  >;

type TAlert = {
  children: ReactNode;
  title: string;
  confirmButtonText?: string;
};

type TApiaUtilInnerAlert = TAlert & { onClose: () => unknown; id: string };

export class ApiaUtilDialogs {
  #maxIdAlert = 0;
  #maxIdConfirm = 0;

  alerts: TApiaUtilInnerAlert[] = [];
  dialogs: TApiaUtilInnerConfirm[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  alert(props: TAlert): Promise<void> {
    return new Promise((resolve) => {
      this.alerts.push({
        ...props,
        onClose: () => resolve(),
        id: `confirm${this.#maxIdAlert++}`,
      });
    });
  }

  confirm(props: TApiaUtilConfirm): Promise<boolean> {
    return new Promise((resolve) => {
      this.dialogs.push({
        ...props,
        id: `confirm${this.#maxIdConfirm++}`,
        onCancel: () => resolve(false),
        onConfirm: () => resolve(true),
      });
    });
  }

  Component = observer(() => {
    const removeModal = useCallback(
      (which: TApiaUtilConfirm & { id: string }) => {
        this.dialogs = this.dialogs.filter((search) => search !== which);
      },
      [],
    );

    return (
      <>
        {this.alerts.map((current) => (
          <AlertModal {...current} key={current.id} />
        ))}
        {this.dialogs.map((current) => (
          <ConfirmModal
            {...current}
            key={current.id}
            onCancel={() => {
              removeModal(current);
              current.onCancel?.();
            }}
            onConfirm={() => {
              removeModal(current);
              current.onConfirm?.();
            }}
          />
        ))}
      </>
    );
  });
}
